module.exports = __webpack_public_path__ + "static/media/Boundary_North.b28e7fbf.jpg";